module.exports = __webpack_public_path__ + "static/media/BG_74.6019864a.gif";